var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _circle, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2062 9.62495C28.1851 8.82407 24.5881 9.13389 20.944 12.0926C19.5585 13.2371 16.4997 16.5676 15.3933 20.6772L15.3641 20.7854L15.2639 20.8357C11.4731 22.7361 5.02361 30.1529 10.354 44.5679C13.6554 53.496 22.3648 56.1761 30.6348 56.2006C34.763 56.2129 38.7573 55.5615 41.8636 54.7085C43.4168 54.2819 44.7432 53.8063 45.7505 53.3407C46.2542 53.1078 46.6744 52.8792 47.0019 52.6626C47.0892 52.6048 47.1689 52.5486 47.2411 52.4941C41.0707 52.5646 34.6652 50.4862 31.7646 49.193C29.3974 48.1821 25.349 45.6914 22.2105 42.8045C20.641 41.3609 19.2843 39.8049 18.4827 38.2718C17.6813 36.7389 17.416 35.1888 18.1093 33.8L18.1241 33.7704L18.1461 33.7456C19.1745 32.5887 20.0982 32.0647 21.1548 32.0493C22.1829 32.0342 23.2899 32.5055 24.671 33.1913C25.005 33.3571 25.3577 33.5371 25.7326 33.7283C28.4795 35.1295 32.414 37.1364 38.8467 38.6415C44.086 39.8673 48.6191 39.8541 52.0826 39.3209C55.4196 38.8072 57.7352 37.8157 58.7433 37.0083C58.6525 36.7668 58.3961 36.296 57.8196 35.7751C57.4108 35.4058 57.0361 34.767 56.7382 34.1494C56.4362 33.5233 56.1967 32.8839 56.0676 32.4833L55.9638 32.1611L56.3022 32.1566C56.9869 32.1475 57.9531 31.9808 58.6496 31.5336C58.9936 31.3126 59.2614 31.0302 59.4067 30.6739C59.5513 30.3197 59.5853 29.8665 59.4171 29.2829L59.3652 29.103L59.5232 29.0026C60.1259 28.6194 60.9119 27.8679 61.3056 26.8741C61.6929 25.8966 61.7098 24.6646 60.7527 23.269L60.7148 23.2137L60.7097 23.1468C60.6003 21.7281 59.4502 19.6417 56.0533 18.8866L55.9671 18.8674L55.9121 18.7984C55.0622 17.7328 53.1482 16.1839 50.5506 15.7062L50.4611 15.6898L50.4031 15.6196C49.5218 14.5528 47.8555 13.1822 45.7399 12.5547C43.6364 11.9308 41.0786 12.0374 38.3755 13.9314L38.1915 14.0603L38.0437 13.8911C36.7072 12.36 34.2415 10.4296 31.2062 9.62495Z",
    fill: "url(#paint0_linear_30_147)",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0282 37.0956C57.051 38.8366 49.3315 41.3513 38.7898 38.8849C24.1024 35.4485 22.3496 29.3931 18.333 33.9117C15.761 39.0632 27.1858 46.9664 31.8646 48.9639C35.4363 50.5567 44.3743 53.3508 51.5532 51.7842C60.5269 49.826 56.2237 43.5206 54.5561 42.055C57.3402 41.819 62.1324 40.4966 59.0282 37.0956Z",
    fill: "url(#paint1_linear_30_147)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5561 42.055C56.2237 43.5206 60.5269 49.826 51.5532 51.7842C44.3743 53.3508 35.4363 50.5567 31.8646 48.9639C27.1858 46.9664 15.761 39.0632 18.333 33.9117C22.3496 29.3931 24.1024 35.4485 38.7898 38.8849C49.3315 41.3513 57.051 38.8366 59.0282 37.0956C62.1324 40.4966 57.3402 41.819 54.5561 42.055ZM54.5561 42.055C53.6577 42.1779 52.5354 42.2927 51.253 42.377M51.253 42.377C45.3669 42.764 36.1063 42.5071 29.628 39.4273C19.7659 34.739 21.2679 37.0139 22.7816 39.0944C24.2953 41.175 27.9058 45.3711 38.7491 48.0116C49.5925 50.6522 59.5987 48.8212 51.253 42.377Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.628 39.4273C19.7659 34.7389 21.2679 37.0139 22.7816 39.0944C23.6981 40.3542 25.3833 42.3895 28.9775 44.3856C31.3192 45.6861 34.4713 46.9699 38.7491 48.0116C49.5924 50.6522 59.5987 48.8211 51.253 42.377C49.2891 42.5061 46.9497 42.5635 44.4633 42.4684C39.4972 42.2783 33.9449 41.4795 29.628 39.4273Z",
    fill: "url(#paint2_linear_30_147)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9775 44.3856C25.3834 42.3895 23.6981 40.3542 22.7816 39.0944C21.2679 37.0139 19.7659 34.7389 29.628 39.4273C33.9449 41.4795 39.4972 42.2783 44.4633 42.4684M28.9775 44.3856C31.3192 45.6861 34.4713 46.9699 38.7491 48.0116C49.5924 50.6522 59.5987 48.8211 51.253 42.377C49.2891 42.5061 46.9497 42.5635 44.4633 42.4684M28.9775 44.3856C29.5307 43.1952 31.3158 41.2062 34.0307 42.7737C37.4243 44.733 41.2261 49.6428 44.9634 47.1752C47.9533 45.2011 45.8758 43.2148 44.4633 42.4684",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6573 29.2136C60.9283 28.4056 62.9679 26.0571 60.959 23.1276C59.0913 21.3119 53.2697 18.5072 44.9252 21.8141C43.5393 19.338 38.4585 15.2852 29.2226 18.8818C28.5156 19.1775 26.916 19.7421 26.1734 19.6351C25.2451 19.5014 24.2818 19.9508 24.6557 20.8705C24.9651 21.6315 26.2425 21.0828 27.0138 22.5336C29.4238 27.0673 41.8228 34.5023 45.481 25.5537C52.9545 31.5578 58.0459 30.4954 59.6573 29.2136Z",
    fill: "#EEEBE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9252 21.8141C53.2697 18.5072 59.0913 21.3119 60.959 23.1276C62.9679 26.0571 60.9283 28.4056 59.6573 29.2136C58.0459 30.4954 52.9545 31.5578 45.481 25.5537M44.9252 21.8141C45.2286 22.3915 45.7646 23.9478 45.481 25.5537M44.9252 21.8141C43.5393 19.338 38.4585 15.2852 29.2226 18.8818C28.5157 19.1775 26.916 19.7421 26.1734 19.6351C25.2451 19.5014 24.2818 19.9508 24.6557 20.8705C24.9651 21.6315 26.2425 21.0828 27.0138 22.5336C29.4238 27.0673 41.8228 34.5023 45.481 25.5537",
    stroke: "black",
    strokeWidth: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.96073,
    cy: 3.04781,
    rx: 2.96073,
    ry: 3.04781,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 60.1146 23.5451)",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.957884,
    cy: 0.957884,
    r: 0.957884,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 57.8163 25.4358)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.57029,
    cy: 3.57029,
    rx: 3.57029,
    ry: 3.57029,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 43.8344 21.7876)",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.04496,
    cy: 1.13204,
    rx: 1.04496,
    ry: 1.13204,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 41.4086 23.2025)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.04496,
    cy: 1.48037,
    rx: 1.04496,
    ry: 1.48037,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 45.5742 23.9988)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.0013,
    cy: 1.2944,
    rx: 1.0013,
    ry: 1.2944,
    transform: "matrix(-0.987572 -0.157169 -0.157169 0.987572 61.3776 25.0787)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_147",
    x1: 59.5006,
    y1: 36.2772,
    x2: 14.6108,
    y2: 13.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D3F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9745E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_147",
    x1: 57.3945,
    y1: 47.4142,
    x2: 16.8854,
    y2: 33.9808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0A465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4BD6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_147",
    x1: 54.1508,
    y1: 48.1558,
    x2: 21.6162,
    y2: 36.4105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D07F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C46786"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e0dc9db4b230bb671290b5afd1878688.svg";
export { ForwardRef as ReactComponent };